module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container charges"
  }, [_c('auto-edit-table', {
    attrs: {
      "defines": _vm.$defines.charge,
      "data": _vm.filtered,
      "title": "水电充值记录",
      "actions": [],
      "buttonAdd": false,
      "pagesize": 20,
      "detail-view": "detail-view",
      "summary": "summary"
    }
  }, [_c('filters-group', {
    attrs: {
      "slot": "afterTitle",
      "data": _vm.charges,
      "result": _vm.filtered
    },
    on: {
      "update:result": function($event) {
        _vm.filtered = $event
      }
    },
    slot: "afterTitle"
  }, [_c('div', {
    staticClass: "ui two columns stackable form grid filters"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("充值时间")]), _c('filter-date-range', {
    attrs: {
      "filter": _vm.$defines.charge.filters.date,
      "select": _vm.select
    },
    on: {
      "update:select": function($event) {
        _vm.select = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("搜索")]), _c('filter-search', {
    attrs: {
      "filter": _vm.$defines.charge.filters.search,
      "defines": _vm.$defines.charge,
      "placeholder": "搜索..."
    }
  })], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-001be584","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Charges.vue
// module id = 354
// module chunks = 0